import "./styles.scss";
import React from "react";

interface AuthenticationFooterProps {
  lineOne?: React.ReactNode;
  lineTwo?: React.ReactNode;
}

const AuthenticationFooter = ({
  lineOne,
  lineTwo,
}: AuthenticationFooterProps) => {
  return (
    <div className="authentication-footer">
      <span className="authentication-footer__line-one">{lineOne}</span>
      <span className="authentication-footer__line-two">{lineTwo}</span>
    </div>
  );
};

export default AuthenticationFooter;
